import { useReveal } from "../lib/useReveal";
import { useParallax } from "../lib/useParallax";

const images = [
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/lu2nwoqo_WhatsApp%20Image%202026-04-25%20at%2012.15.02%20AM.jpeg",
    tag: "Gaushala",
    title: "Under the old tree",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/pdjd72v5_WhatsApp%20Image%202026-04-25%20at%208.03.16%20PM.jpeg",
    tag: "Treatment",
    title: "Cleaning a serious wound",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/o4l9bkb1_WhatsApp%20Image%202026-04-25%20at%208.01.13%20PM.jpeg",
    tag: "Operation",
    title: "Pre-op — steady hands",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/6ogiab7k_WhatsApp%20Image%202026-04-24%20at%204.05.20%20PM%20%286%29.jpeg",
    tag: "Shelter",
    title: "A quiet corner to heal",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/a35vv9nm_WhatsApp%20Image%202026-04-25%20at%2012.15.29%20AM.jpeg",
    tag: "Camels",
    title: "Four old companions, resting",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/dpygh0ia_WhatsApp%20Image%202026-04-25%20at%2012.11.57%20AM.jpeg",
    tag: "Nilgai",
    title: "Our five deer, home now",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/zxd7niru_WhatsApp%20Image%202026-04-25%20at%208.03.16%20PM%20%281%29.jpeg",
    tag: "Surgery",
    title: "In the operation theatre",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/vwbwyvzv_5cd9eb59-b834-4279-a701-7337dfc7f6b6.jpg",
    tag: "Rescue",
    title: "Mother and calf, reunited",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/zvfor0s6_e9ed47b9-b441-4fb3-8b1e-c3b2873d31e2.jpg",
    tag: "Calves",
    title: "The little ones, resting after lunch",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/rz4iejg1_0cf67524-2d8d-45c7-9513-ca6d602fbf4f.jpg",
    tag: "Shelter",
    title: "Shaded sheds, fresh water — every day",
  },
];

function GalleryItem({ img, i, spanClass }) {
  // Different parallax speeds per item creates the "depth/walk-by" feel
  const speed = i === 0 ? 0.16 : (i % 3 === 0 ? 0.12 : 0.08);
  const imgRef = useParallax(speed);
  return (
    <figure
      data-testid={`gallery-item-${i}`}
      className={`group relative overflow-hidden rounded-2xl ${spanClass} min-h-[220px] md:min-h-[280px]`}
    >
      <img
        ref={imgRef}
        src={img.src}
        alt={img.title}
        loading="lazy"
        className="absolute -top-[10%] left-0 w-full h-[120%] object-cover will-change-transform transition-transform duration-[900ms] group-hover:scale-[1.04]"
      />
      <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-[#1A2E24]/90 via-[#1A2E24]/40 to-transparent" />
      <figcaption className="absolute left-5 bottom-5 right-5">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
          {img.tag}
        </div>
        <div className="font-display text-[#FDFBF7] text-xl md:text-2xl mt-1">
          {img.title}
        </div>
      </figcaption>
    </figure>
  );
}

export default function Gallery() {
  const ref = useReveal();
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-[#F4F1EA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-[1px] w-10 bg-[#D4AF37]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#4A5D53]">Gallery</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A2E24] leading-[1.05]">
              Moments of <span className="italic text-[#1B4D3E]">healing</span>, quietly captured.
            </h2>
          </div>
          <p className="text-[#4A5D53] max-w-sm">
            A glimpse into ordinary mornings at our home — because the
            miracle is in the ordinary.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {images.map((img, i) => {
            const spans = [
              "col-span-12 md:col-span-8 row-span-2",
              "col-span-12 md:col-span-4",
              "col-span-12 md:col-span-4",
              "col-span-6 md:col-span-4",
              "col-span-6 md:col-span-4",
              "col-span-6 md:col-span-4",
              "col-span-12 md:col-span-6",
              "col-span-12 md:col-span-6",
              "col-span-12 md:col-span-8 row-span-2",
              "col-span-12 md:col-span-4",
            ];
            return <GalleryItem key={i} img={img} i={i} spanClass={spans[i]} />;
          })}
        </div>
      </div>
    </section>
  );
}
